import { each } from 'lodash';

export function clearRecords(value: any) {
    if (isPrimitive(value)) {
        switch (typeof value) {
            case 'string':
                value = '';
                break;
            case 'number':
                value = null;
                break;
            case 'boolean':
                value = false;
                break;
            default:
                value = null;
                break;
        }
    }
    each(value, (v, k) => {
        if (Array.isArray(v)) {
            value[k] = [];
        } else {
            switch (typeof v) {
                case 'string':
                    value[k] = '';
                    break;
                case 'number':
                    value[k] = null;
                    break;
                case 'boolean':
                    value[k] = false;
                    break;
                default:
                    value[k] = null;
                    break;
            }
        }
    });
}

export function isPrimitive(value: any) {
    // eslint-disable-next-line unicorn/new-for-builtins
    return value !== Object(value);
}
